import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import doneSuccessIcon from '../../../assets/petDemos/done-success.svg';
import rightArrowIcon from '../../../assets/petDemos/chevron.svg';

import styles from './GenericEmailSuccessStep.module.css';

const GenericEmailSuccessStep = ({
  email = '',
  onContinuePress = () => { },
  customI18nKeyDescription = '',
  customContinueButtonText = '',
}) => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.container}>
      <img alt="" src={doneSuccessIcon} />

      <h1 className={styles.title}>
        {t('certificateLinking.linkedEmailSuccess.title')}
      </h1>

      <p className={styles.description}>
        <Trans
          components={{ b: <span className={styles.descriptionBold} /> }}
          i18nKey={customI18nKeyDescription
            || 'certificateLinking.linkedEmailSuccess.description'}
          t={t}
          values={{ email }}
        />
      </p>

      <button
        className={styles.continueButton}
        onClick={onContinuePress}
        type="button"
      >
        {customContinueButtonText
          || t('certificateLinking.linkedEmailSuccess.continue')}

        <img alt="" className={styles.rightArrow} src={rightArrowIcon} />
      </button>
    </div>
  );
};

export { GenericEmailSuccessStep };
